<div class="page-wrapper">
  <div class="page-header list-page-header mb-3">
    <div class="d-flex align-items-center gap-2">
      <h4 class="page-title">All TRANSACTIONS</h4>
    </div>
  </div>

  <div class="panel-div">
    <div class="table-wrapper border-radius-full">
      <table class="role-table amc-table" appAutoDataLabel>
        <thead class="amc-table-heading">
          <tr>
            <th class="ps-3">Account Number</th>
            <th>Amount</th>
            <th>Transaction Type</th>
            <th>Transaction Date</th>
            <th>Transaction Status</th>
            <th>Created By</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @if(isLoading || isSearching){
          <tr class="border-0 tr-table-loader">
            <td [colSpan]="5" class="td-table-loader">
              <app-bounce-loader></app-bounce-loader>
            </td>
          </tr>
          } @else { @if(!searchedtransactionsNotFound){
          <tr *ngFor="let transaction of transactions; let i = index">
            <td>
              {{ transaction?.accountNumber }}
            </td>
            <td>
              {{ transaction?.transactionAmount | nairaCurrency }}
            </td>

            <td data-label="Transaction Type">
              {{ transaction?.transactionType | uppercase }}
            </td>

            <td data-label="Transaction Date">
              {{ transaction?.transactionDate | lowercase }}
            </td>

            <td data-label="Transaction Status" class="fw-semibold">
              <span
                class="warning-label"
                [ngClass]="
                  'status-text-' + transaction?.transactionStatus | lowercase
                "
                >{{ transaction?.transactionStatus }}</span
              >
            </td>

            <td data-label="Transaction Date">
              {{ transaction?.createdBy | lowercase }}
            </td>

            <td data-label="Action">
              <div class="amc-table-action-wrapper">
                <span
                  class="material-symbols-outlined action-icon"
                  data-bs-toggle="dropdown"
                >
                  more_horiz
                </span>
                <div class="dropdown-menu amc-table-action-select">
                  <div class="dropdown-wrapper">
                    <div class="action-btn disabled">NO ACTION</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          } @else{
          <tr class="tr-empty-placeholder">
            <td colspan="5" class="text-center">No results found</td>
          </tr>
          } }
        </tbody>
      </table>
    </div>
  </div>

  <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">
    <div class="d-flex align-items-center me-4">
      <div>Rows per page:</div>
      <div class="mx-2">
        <select
          class="form-control px-6 text-center"
          style="width: auto; min-width: 40px"
          [(ngModel)]="selectedLimit"
          (change)="updateLimit()"
        >
          <option [value]="5">5</option>
          <option [value]="10">10</option>
          <option [value]="20">20</option>
          <option [value]="30">30</option>
          <option [value]="40">40</option>
          <option [value]="50">50</option>
        </select>
      </div>
    </div>

    <div class="pagination-container">
      <ngb-pagination
        *ngIf="!isSearching && count > 0"
        [(page)]="currentPage"
        (pageChange)="callDb($event)"
        [maxSize]="5"
        [pageSize]="pageSize"
        [collectionSize]="count"
        [boundaryLinks]="true"
        [directionLinks]="true"
        [rotate]="true"
        class="pagination justify-content-center my-3"
      >
      </ngb-pagination>
    </div>
  </div>
</div>
